import React from "react";

const LeftAboutSection2 = () => {
  return (
    <div id="guidelines">
      <div className="left  lg:w-full">
        <div className="mt-48">
          <h1 className="text-3xl font-bold lg:text-5xl">ORDINANCE</h1>
          <div className="mt-5  ">
            <img
              className="w-[100%] lg:mt-12 "
              src="https://us.123rf.com/450wm/deeaf/deeaf1606/deeaf160600130/59272367-the-words-school-rules-on-paper.jpg?ver=6"
              alt=""
            />
          </div>
        </div>
        <div>
          <p className="mt-9 font-sans text-xl">
            The first major factor of importance of school rules is that it
            enables students to remain focused and most likely excel in their
            education. School rules, helps maintain discipline by ensuring that
            the students are aware of how to behave and the consequences of
            misbehaving.
          </p>
        </div>
        <div className="w-2 bg-black">
          <div className="mt-10 lg:flex  ">
            <div className="mx-5  ">
              <ul className="w-80 cursor-pointer font-serif text-2xl">
                {/* <li className="hover:text-blue-400">
                {" "}
                <a className="text-bold text-red-600"> Be </a>polite, friendly and
                well behaved..{" "}
              </li> */}
                <li className="hover:text-blue-400">
                  {" "}
                  <a className="text-bold text-red-600"> Bullying</a> is
                  strictly prohibited
                </li>
                {/* <li className="hover:text-blue-400">
                {" "}
                <a className="text-bold text-red-600"> Take</a> care of school
                property..
              </li> */}

                <li className="hover:text-blue-400">
                  {" "}
                  <a className="text-bold text-red-600"> Homework</a> Board is
                  updated daily
                </li>
                <li className="hover:text-blue-400">
                  {" "}
                  <a className="text-bold text-red-600"> Close</a> the taps
                  after use in the drinking area & washrooms
                </li>
                <li className="hover:text-blue-400">
                  <a className="text-bold text-red-600"> Students</a> are not
                  allowed to visit the Staff-room
                </li>
              </ul>
            </div>
            <div className="mx-5 bg-black lg:w-2 ">
              <ul className="w-80 cursor-pointer font-serif text-2xl lg:mx-11">
                <li className="hover:text-blue-400">
                  {" "}
                  <a className="text-bold text-red-600">Come</a> to school on
                  time
                </li>
                <li className="hover:text-blue-400">
                  {" "}
                  <a className="text-bold text-red-600"> Bring</a> the school
                  diary every day
                </li>
                {/* <li className="hover:text-blue-400">
                {" "}
                <a className="text-bold text-red-600"> Attend </a>School Regularly
              </li> */}

                {/* <li className="hover:text-blue-400">
                <a className="text-bold text-red-600"> Be </a>well groomed..
              </li> */}

                <li className="hover:text-blue-400">
                  <a className="text-bold text-red-600"> Switch</a> off the fans
                  and lights after use
                </li>
                <li className="hover:text-blue-400">
                  {" "}
                  <a className="text-bold text-red-600"> Be </a> respectful to
                  their elders, teachers and truthful{" "}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftAboutSection2;
